export default class Dropdown {
  private readonly wrapper: HTMLElement;
  private readonly activator?: HTMLElement;
  private readonly menu?: HTMLElement;
  private isMenuOpened = false;

  constructor(element: HTMLElement) {
    this.wrapper = element;
    const activatorNode = element.querySelector('a');
    if (!activatorNode) {
      return;
    }

    const menuNode = element.querySelector('.dropdown-menu');
    if (!menuNode) {
      return;
    }

    this.activator = activatorNode as HTMLElement;
    this.menu = menuNode as HTMLElement;
    activatorNode.addEventListener('click', e => this.toggleClickHandler(e), false);
  }

  private toggleClickHandler(_e: Event): void {
    if (!this.menu) {
      return;
    }

    if (this.isMenuOpened) {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      document.removeEventListener('click', this.dismissClickHandler, false);
      this.wrapper.classList.remove('open');
      this.menu.classList.remove('show');
    } else {
      document.addEventListener('click', e => this.dismissClickHandler(e), false);
      this.wrapper.classList.add('open');
      this.menu.classList.add('show');
    }
    this.isMenuOpened = !this.isMenuOpened;
  }

  private dismissClickHandler(e: Event): void {
    if (this.menu && this.isMenuOpened && e.target !== this.menu && e.target !== this.activator) {
      this.wrapper.classList.remove('open');
      this.menu.classList.remove('show');
      this.isMenuOpened = false;
    }
  }
}
